<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <a href="#" id="download_img" target="_blank"></a>

    <img @click="downloadScreenshot()" draggable="false" class="clickable" id="reset_btn_top" src="./../../assets/images/Asset 44_.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/kerstmis/Asset 48.png" alt="">
    <img draggable="false" id="kerstmis_top_image" src="./../../assets/images/kerstmis/Asset 61.png" alt="">
    
    <img draggable="false" v-if="$store.getters['kerstmis/selected_tree'] == 63" id="tree_image_game" src="./../../assets/images/kerstmis/Asset 63.png" alt="">
    <img draggable="false" v-if="$store.getters['kerstmis/selected_tree'] == 64" id="tree_image_game" src="./../../assets/images/kerstmis/Asset 64.png" alt="">
    <img draggable="false" v-if="$store.getters['kerstmis/selected_tree'] == 65" id="tree_image_game" src="./../../assets/images/kerstmis/Asset 65.png" alt="">

    <img class="clickable" draggable="false" id="kerstmis_item_1" src="./../../assets/images/kerstmis/Asset 72.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_2" src="./../../assets/images/kerstmis/Asset 72.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_3" src="./../../assets/images/kerstmis/Asset 75.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_4" src="./../../assets/images/kerstmis/Asset 71.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_5" src="./../../assets/images/kerstmis/Asset 74.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_6" src="./../../assets/images/kerstmis/Asset 73.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_7" src="./../../assets/images/kerstmis/Asset 68.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_8" src="./../../assets/images/kerstmis/Asset 69.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_9" src="./../../assets/images/kerstmis/Asset 68.png" alt="">
    <img class="clickable" draggable="false" id="kerstmis_item_10" src="./../../assets/images/kerstmis/Asset 77.png" alt="">
  </span>
</template>

<script>
// https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable

export default {
  name: "KerstmisGame",
  mounted() {
    dragElement(document.getElementById("kerstmis_item_1"));
    dragElement(document.getElementById("kerstmis_item_2"));
    dragElement(document.getElementById("kerstmis_item_3"));
    dragElement(document.getElementById("kerstmis_item_4"));
    dragElement(document.getElementById("kerstmis_item_5"));
    dragElement(document.getElementById("kerstmis_item_6"));
    dragElement(document.getElementById("kerstmis_item_7"));
    dragElement(document.getElementById("kerstmis_item_8"));
    dragElement(document.getElementById("kerstmis_item_9"));
    dragElement(document.getElementById("kerstmis_item_10"));

    function dragElement(elmnt) {
      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      if (document.getElementById(elmnt.id + "header")) {
        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
      } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
      }

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    }
  },

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    downloadScreenshot() {
      initScreenshot()

      setTimeout(function() {
        $('#download_img')[0].click()
      }, 500);
    },
    goToStart() {
      this.$store.dispatch('kerstmis/asyncUpdateSelectedTree', {
          selected_tree: null,
      });

      this.$router.push('/kerstmis/start');
    },
    goToKerstmisMenu() {
      this.$router.push('/kerstmis/menu/1');
    },
  },

  computed: {}
};
</script>

<style>
  #kerstmis_item_1 {
    position: absolute;
    top: 20%;
    left: 4%;
    width: 5%;
  }
  #kerstmis_item_2 {
    position: absolute;
    top: 37%;
    left: 4%;
    width: 5%;
  }
  #kerstmis_item_3 {
    position: absolute;
    top: 55%;
    left: 4%;
    width: 5%;
  }
  #kerstmis_item_4 {
    position: absolute;
    top: 64%;
    left: 12%;
    width: 10%;
  }
  #kerstmis_item_5 {
    position: absolute;
    top: 40%;
    left: 12%;
    width: 10%;
  }
  #kerstmis_item_6 {
    position: absolute;
    top: 15%;
    left: 12%;
    width: 10%;
  }
  #kerstmis_item_7 {
    position: absolute;
    top: 15%;
    left: 25%;
    width: 3%;
  }
  #kerstmis_item_8 {
    position: absolute;
    top: 25%;
    left: 27%;
    width: 3%;
  }
  #kerstmis_item_9 {
    position: absolute;
    top: 40%;
    left: 27%;
    width: 3%;
  }
  #kerstmis_item_10 {
    position: absolute;
    top: 50%;
    left: 25%;
    width: 10%;
  }
  #tree_image_game {
    position: absolute;
    margin-top: 10%;
    left: 37%;
    width: 32%;
  }
</style>


